export default __webpack_public_path__ + "src/assets/outbound.d467e62fde25ba19e4facd9a3cae077b.svg";